import React, { useEffect, useState } from "react";
import { Button, Modal} from "react-bootstrap";
import "../styles.css";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import Invoice from "../libs/Invoice";

function InvoiceLayout({
  show,
  handleClose,
  invoiceData,
}) {
  const { t } = useTranslation();
  const { values } = useFormikContext();

  const [htmlContent, setHtmlContent] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (show) {
      Invoice.previewInvoice(values)
        .then(res => setHtmlContent(res))
        .catch(e => {
          setError(e.message)
        })
    }
  }, [show]);



  return (
      <Modal show={show} onHide={handleClose} size="lg" className="p-0">
      {error && <Modal.Body><div className="alert alert-danger">{error}</div></Modal.Body>}

      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />

      <Modal.Footer>
        <Button variant="primary" onClick={() => handleClose()}>
          {t("Close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default InvoiceLayout;
